import axios from './axios';

const getByAuthenticated = async () => {

    return axios.get(`users`).then(response => response.data).then(data => ({item: prepare(data)}));
};

const prepare = (items) => {

    const wasArray = Array.isArray(items);

    items = (wasArray ? items : [items]).map(item => {

        return {

            allowMailing: item.allowmailing,
            displayName: item.displayname,
            email: item.username,
            hash: item.hash,
        };
    });

    return wasArray ? items : items[0];
};

const save = async ({email, displayName, allowMailing, device}) => {

    return axios.post(`users`, {

        allowmailing: allowMailing,
        devicehash: device.devicehash,
        deviceid: device.deviceid,
        displayname: displayName,
        username: email,

    }).then(response => response.data);
};

const updateByAuthenticated = async ({email, displayName, allowMailing, device}) => {

    return axios.put(`users`, {

        allowmailing: allowMailing,
        devicehash: device.devicehash,
        deviceid: device.deviceid,
        displayname: displayName,

    }).then(response => response.data).then(data => ({item: prepare(data)}));
};

const validate = async ({email, code, device}) => {

    return axios.put(`users`, {

        devicehash: device.devicehash,
        deviceid: device.deviceid,
        username: email,
        validationcode: code,

    }).then(response => response.data).then(data => ({item: prepare(data)}));
};

export {

    getByAuthenticated,
    save,
    updateByAuthenticated,
    validate,
}



// WEBPACK FOOTER //
// ./src/components/services/users.js